import { MediaType, OwnerObjectType } from "@prisma/client"
import { createClinicMediaRequest } from "api"
import { INSERT_IMAGE_COMMAND } from "components/v2/components/common/RichTextEditorV2/plugins/ImagesPlugin/ImagesPlugin"
import { INSERT_VIDEO_COMMAND } from "components/v2/components/common/RichTextEditorV2/plugins/VideosPlugin/VideosPlugin"
import { toast } from "react-toastify"

export async function educationalContentMediaUploadService({
    file,
    mediaType,
    libraryTemplate,
    educationalContent,
    uploadImage,
    uploadVideo,
    t,
    editor,
    onSuccess,
    onError
}: {
    file: File
    mediaType: MediaType
    libraryTemplate: any
    educationalContent: any
    uploadImage: any
    uploadVideo: any
    t: any
    editor?: any
    onSuccess?: (response: any) => void
    onError?: (error: any) => void
}) {
    try {
        if (!libraryTemplate?.id || !educationalContent?.id) {
            throw new Error("Missing required IDs")
        }

        const folderPath = `educational_content/${educationalContent.id}`
        const tags = ["educational_content", educationalContent.id.toString()]

        const uploadedFile = await (mediaType === MediaType.IMAGE ? uploadImage : uploadVideo)({
            folderPath,
            tags,
            file
        })

        const mediaData = {
            ownerObjectType: OwnerObjectType.EDUCATIONAL_CONTENT,
            ownerObjectId: libraryTemplate.id,
            savedFileName: uploadedFile.public_id,
            savedFilePath: uploadedFile.secure_url,
            storageProviderMetadata: {
                tags: uploadedFile.tags || [],
                cloudName: process.env.NEXT_PUBLIC_CLOUDINARY_CLOUD_NAME,
                public_id: uploadedFile.public_id
            },
            uploadResultString: JSON.stringify(uploadedFile),
            originalFileType: uploadedFile.format,
            originalFileName: uploadedFile.original_filename || file.name,
            size: uploadedFile.bytes,
            mediaType,
            contentId: educationalContent.id.toString()
        }

        const response = await createClinicMediaRequest(mediaData)
        toast(t("common:fileUpload.success"), { type: "success" })
        if (editor) {
            editor.dispatchCommand(
                mediaType === MediaType.IMAGE ? INSERT_IMAGE_COMMAND : INSERT_VIDEO_COMMAND,
                response
            )
        }
        if (onSuccess) onSuccess(response)
    } catch (error) {
        console.error("Error processing upload:", error)
        toast(t("common:wentWrong"), { type: "error" })
        if (onError) onError(error)
    }
}
